import React from "react";
import "../style/Products.css";
import ProductCard from "./ProductCard";
import { productDetails } from "../data/productData";

const Products = () => {
  return (
    <section id="products" className="products">
      <div className="section-heading">
        <h2 className="section-title">Our Products</h2>
        <p className="section-subtitle">
          Thoughtfully formulated haircare essentials, made in small batches
          with ingredients you can trust.
        </p>
      </div>
      <div className="products-grid">
        {productDetails.map((product) => (
          <ProductCard
            key={product.id}
            name={product.name}
            size={product.size}
            description={product.description}
            img={product.img}
            amazonLink={product.amazonLink}
            amazonDisabled={product.amazonDisabled}
            meeshoLink={product.meeshoLink}
          />
        ))}
      </div>
    </section>
  );
};

export default Products;
